/**
 * Created by maciej on 22/06/2016.
 */
import {app} from '../app';
import moment = require("moment/moment");
import Duration = moment.Duration;
import {SharedQuestion} from "../sharedQuestions/SharedQuestion";
import {TextSharedQuestion} from "../sharedQuestions/TextSharedQuestion";
import {EmailSharedQuestion} from "../sharedQuestions/EmailSharedQuestion";
import {PageSharedQuestion} from "../sharedQuestions/PageSharedQuestion";
import {StaticSharedQuestion} from "../sharedQuestions/StaticSharedQuestion";
import {LikertScaleSharedQuestion} from "../sharedQuestions/LikertScaleSharedQuestion";
import {SessionService} from "./SessionService";
import {ISessionService} from "./SessionService";
import {PageDynamicSharedQuestion} from "../sharedQuestions/PageDynamicSharedQuestion";
import {SelectSharedQuestion} from "../sharedQuestions/SelectSharedQuestion";
import {SelectNumericSharedQuestion} from "../sharedQuestions/SelectNumericSharedQuestion";
import {CheckboxSharedQuestion} from "../sharedQuestions/CheckboxSharedQuestion";
import {RadioSharedQuestion} from "../sharedQuestions/RadioSharedQuestion";
import {RadioGridSharedQuestion} from "../sharedQuestions/RadioGridSharedQuestion";
import {RateSharedQuestion} from "../sharedQuestions/RateSharedQuestion";
import {ForceRankQuestionComponent} from "../components/QuestionTypes/ForceRankQuestionComponent";
import {ForceRankSharedQuestion} from "../sharedQuestions/ForceRankSharedQuestion";
import {UploadSharedQuestion} from "../sharedQuestions/UploadSharedQuestion";
import {ReviewSharedQuestion} from "../sharedQuestions/ReviewSharedQuestion";

export class SharedQuestionService extends SharedQuestion {

    private sessionService:ISessionService;

    questions:SharedQuestion[] = [];

    sharedQuestions = {
        'text'          : TextSharedQuestion,
        'email'         : EmailSharedQuestion,
        'likert-scale'  : LikertScaleSharedQuestion,
        'page'          : PageSharedQuestion,
        'page-dynamic'  : PageDynamicSharedQuestion,
        'static'        : StaticSharedQuestion,
        'select'        : SelectSharedQuestion,
        'select-numeric': SelectNumericSharedQuestion,
        'checkbox'      : CheckboxSharedQuestion,
        'radio'         : RadioSharedQuestion,
        'radio-grid'    : RadioGridSharedQuestion,
        'rate'          : RateSharedQuestion,
        'force-rank'    : ForceRankSharedQuestion,
        'bars'          : RadioSharedQuestion,
        'upload'        : UploadSharedQuestion,
        'review'        : ReviewSharedQuestion
    };

    constructor(SessionService:ISessionService) {
        super();

        this.sessionService = SessionService;

        this.sessionService.onSessionResumed(() => {
            this.sessionResumed();
        });
        this.sessionService.onSessionPaused(() => {
            this.sessionPaused();
        });
    }

    isValid():boolean {
        for (let question of this.questions) {
            if (!question.isValid())
                return false;
        }

        return true;
    }

    getValue():any {
        var values = [];
        this.questions.forEach(question => values.push(question.getValue()));
        return values;
    }

    setValue(value:any) {
        throw new Error("Cannot set value to SharedQuestionService");
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        throw new Error("Cannot check whether SharedQuestionService satisfies value");
    }

    sessionPaused() {
        for (let question of this.questions) {
            question.sessionPaused();
        }
    }

    sessionResumed() {
        for (let question of this.questions) {
            question.sessionResumed();
        }
    }

    static sortQuestions(questions:IQuestion[]):IQuestion[] {
        return questions.sort((a, b) => {
            return a.id - b.id;
        });
    }

    static recursiveForEachQuestions(questions:IQuestion[], callback: (question:IQuestion) => void) {
        for (const question of questions) {
            callback(question);

            if (question.questions) {
                SharedQuestionService.recursiveForEachQuestions(question.questions, callback);
            }
        }
    }

    static factory() {
        const factory   = (SessionService:ISessionService) => new SharedQuestionService(SessionService);
        factory.$inject = ['SessionService'];
        return factory;
    }

}

app.factory('SharedQuestionService', SharedQuestionService.factory());